import { cnpjService, cepService } from 'packages/common';
import { sortValuesObject, formatCnpjCpf } from 'packages/common/utils';
import resource from '../../resource';
import { clickSaveServiceTakerTracker } from './serviceTakerTrackerService';

export function getServiceTakersList({ pagination } = {}) {
  const page = pagination?.page ? pagination.page - 1 : 0;

  return getServiceTakers({ page, transformType: 'LIST_ITEM' });
}

export function getServiceTakersListSearching(searchTerm = '') {
  return getServiceTakers({ transformType: 'LIST_ITEM', search: searchTerm });
}

export function getServiceTakers(params = {}) {
  return resource.getServiceTakers(params)
    .then(res => res.data);
}

export function getServiceTaker(id) {
  return resource.getServiceTaker(id)
    .then(res => res.data);
}

export function deleteServiceTaker(id) {
  return resource.deleteServiceTaker(id);
}

function parseCnpjInformationPayload(data) {
  const {
    companyName: serviceTakerName,
    streetName: street,
    addressNumber: residenceNumber,
    addressComplement: complement,
    state: uf,
    neighborhood,
    zipCode,
  } = data;

  return {
    serviceTakerName,
    zipCode,
    complement,
    neighborhood,
    residenceNumber,
    street,
    state: { uf },
  };
}

export function getCnpjInformation(cnpj) {
  return cnpjService.getCnpjInformation(cnpj)
    .then(data => parseCnpjInformationPayload(data));
}

function parseZipCodeInformationPayload(data) {
  const {
    city: cityName,
    streetAddress: street,
    state: uf,
    cityCode,
    neighborhood,
    complement,
  } = data;

  return {
    street,
    complement,
    neighborhood,
    state: { uf },
    city: {
      cityName,
      code: Number(cityCode),
    },
  };
}

export function getZipCodeInformation(cep) {
  return cepService.getCepInformation(cep)
    .then(res => parseZipCodeInformationPayload(res));
}

export function getStates() {
  return resource.getStates()
    .then(res => res.data.sort((a, b) => sortValuesObject(a, b, 'uf')));
}

export function getCities(uf) {
  return resource.getCities(uf)
    .then(res => res.data.sort((a, b) => sortValuesObject(a, b, 'cityName')));
}

export function createServiceTaker(data) {
  const registration = formatCnpjCpf(data.registration);

  clickSaveServiceTakerTracker();
  return resource.createServiceTaker({ ...data, registration });
}

export function updateServiceTaker(data) {
  const registration = formatCnpjCpf(data.registration);

  return resource.updateServiceTaker({ ...data, registration });
}

export function deleteBatchServiceTaker(data) {
  return resource.deleteBatchServiceTaker(data);
}
